import type { NewsItem } from '../../../../../../../corelogic/domain/models/hub.model';

export const newsItems: NewsItem[] = [
  {
    id: '1',
    title:
      'One To Watch - UFC 318: Poirier vs Holloway on 19.07. for the BMF Championship',
    date: 'July 6, 2025',
    shortDescription:
      'Dustin Poirier faces Max Holloway for the BMF belt in his retirement fight',
    fullContent: `UFC 318 on 19th of July features an emotional main event as Dustin Poirier takes on Max Holloway for the coveted BMF championship. This fight holds special significance as it marks Poirier's retirement bout, bringing an end to one of the most legendary careers in MMA.

Both fighters are former interim Lightweight champions with incredible striking skills and heart. Fantasy players should expect fireworks in this five-round war, with both men having nothing left to lose.`,
  },
  {
    id: '2',
    title: 'Two New Seasons Added: July & August 2025',
    date: 'July 6, 2025',
    shortDescription:
      'Exciting new seasons featuring packed schedules of UFC events',
    fullContent: `We're thrilled to announce the addition of two new fantasy seasons for July and August 2025! These action-packed months will feature multiple UFC events with incredible matchmaking opportunities.<br /><br />
<strong>July 2025 Events:</strong><br />
• UFC Fight Night: Lewis vs. Teixeira - July 12, 2025 (Nashville, Tennessee)<br />
• UFC 318: Holloway vs. Poirier 3 - July 19, 2025 (New Orleans, Louisiana)<br />
• UFC Fight Night: Whittaker vs. De Ridder - July 26, 2025 (Abu Dhabi, UAE)<br /><br />
<strong>August 2025 Events:</strong><br />
• UFC Fight Night: Albazi vs. Taira - August 2, 2025 (Las Vegas, Nevada)<br />
• UFC Fight Night: Dolidze vs. Hernandez - August 9, 2025 (Las Vegas, Nevada)<br />
• UFC 319: Du Plessis vs. Chimaev - August 16, 2025 (Chicago, Illinois)<br />
• UFC Fight Night: Walker vs. Zhang - August 23, 2025 (Shanghai, China)<br /><br />
Check out the Fighters To Watch section below for inspiration on who to pick for your team!`,
  },
  {
    id: '3',
    title: 'New Tournaments Feature Now Live!',
    date: 'June 6, 2025',
    shortDescription:
      'Create private tournaments and compete in global leaderboards',
    fullContent: `We're thrilled to introduce our brand new Tournaments feature! Now you can take your fantasy MMA experience to the next level with both private and global competition options.<br /><br />
<strong>What's New:</strong><br />
• <strong>Private Tournaments:</strong> Create your own custom tournaments and invite friends, family, or colleagues to compete<br />
• <strong>Global Annual Leaderboard:</strong> Compete against all Fantasy MMA players worldwide across the entire year<br />
• <strong>Seasonal Leaderboards:</strong> Participate in monthly season competitions with focused scoring periods<br />
• <strong>Tournament Management:</strong> Set up password-protected private tournaments with custom rules<br />
• <strong>Real-time Rankings:</strong> Track your performance against other players with live leaderboard updates<br /><br />
Settle bragging rights with your friends or prove you're the ultimate fantasy MMA strategist on the global stage!`,
  },
];
